import { all } from "redux-saga/effects";
import { combineReducers } from "redux";

import * as auth from "../app/modules/Auth/_redux/authRedux";
import { springApi } from "./springApi";
import { sfAiDjangoApi } from "./sfAiDjangoApi";
import ui from "./uiSlice";
export const rootReducer = combineReducers({
  auth: auth.reducer,
  [springApi.reducerPath]: springApi.reducer,
  [sfAiDjangoApi.reducerPath]: sfAiDjangoApi.reducer,
  ui,
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
